// extracted by mini-css-extract-plugin
export default {"container":"Partners_container__yriIi","row":"Partners_row__JCLwX","citadele":"Partners_citadele__C1AKL","bfjord":"Partners_bfjord__zrKTZ"};